import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import installAuthGuard from './asset/js/authGuard';
// import 'react-app-polyfill/ie11';

//세션 만료(401) 전역 안내 — 어느 화면에서든 첫 401에서 한 번만 뜬다
installAuthGuard('로그인 정보가 만료되었습니다.\n학습창을 닫고 다시 입장해 주세요.', function () {
    window.close();
});

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
